<template>
  <div class="outer-wrapper">
    <div class="top-content">
      <div class="left-content">
        <Collapse v-model="value1">
          <Panel name="1">
            设置原则
            <div slot="content" class="content-i"><div v-html="description.a"></div></div>
          </Panel>
          <Panel name="2">
            应急点职责
            <div slot="content" class="content-i"><div v-html="description.b"></div></div>
          </Panel>
          <Panel name="3">
            人员及物资配置
            <div slot="content" class="content-i"><div v-html="description.c"></div></div>
          </Panel>
          <Panel name="4">
            人员及物资管理
            <div slot="content" class="content-i"><div v-html="description.d"></div></div>
          </Panel>
          <Panel name="5">
            值守及响应要求
            <div slot="content" class="content-i"><div v-html="description.e"></div></div>
          </Panel>
          <Panel name="6">
            非运营期间
            <div slot="content" class="content-i"><div v-html="description.f"></div></div>
          </Panel>
        </Collapse>
      </div>
      <img
        :src="imgUrl"
        alt
        style="width: 500px; height: 500px; cursor: pointer"
        @click="linkTo(imgUrl)"
      />
    </div>
    <Tabs value="name1">
      <!-- <TabPane label="应急点" name="name1" v-if="false">
        <div style="border:1px solid #bbb;padding:20px 20px;margin-top:-17px;">
          <List item-layout="vertical">
            <ListItem v-for="(item,index) in data" :key="index">
              <ListItemMeta
                :avatar="item.avatar"
                :title="item.title"
                :description="item.description"
              />
              <p style="padding-left:50px;">{{ item.content }}</p>
              
              <template slot="action">
                <li style="padding-left:50px;" v-show="item.remark===undefined">
                  <Icon type="ios-star-outline" />
                  <span >注：站名后数字为线路号。</span>
                  
                </li>
                <li>
                    <Icon type="ios-thumbs-up-outline" /> 234
                </li>
                <li>
                    <Icon type="ios-chatbubbles-outline" /> 345
                </li>
              </template>
              <template slot="extra">
                <img :src="item.img" style="width: 280px" />
              </template>
            </ListItem>
          </List>
        </div>
      </TabPane> -->
      <TabPane label="应急值守点" name="name1">
        <query-table
          :columnsFormatData="columnsFormatData"
          askData="emergencyList"
          :refreshData="update_count"
          main_width="1260px"
        ></query-table>
      </TabPane>
      <TabPane label="区域应急中心" name="name3">
        <query-table
          :columnsFormatData="columnsFormatArea"
          askData="emergencyList"
          :refreshData="update_count"
          main_width="1260px"
        ></query-table>
        </TabPane>
      <TabPane label="应急基地" name="name2">
        </TabPane>
        
        <TabPane label="应急物资" name="name4">
          <query-table
          :columnsFormatData="columnsFormatGoods"
          askData="emergencyGoodsList"
          :refreshData="update_count"
          main_width="1260px"
        ></query-table>
        </TabPane>
        <TabPane label="应急演练预案" name="name5">
          <query-table
          :columnsFormatData="columnsFormatScheme"
          askData="emergencySchemeManage"
          :refreshData="update_count"
          main_width="1260px"
        ></query-table>
        </TabPane>
        <TabPane label="应急演练计划" name="name6">
          <query-table
          :columnsFormatData="columnsFormatPlan"
          askData="emergencyPlanManage"
          :refreshData="update_count"
          main_width="1260px"
        ></query-table>
        </TabPane>
        <TabPane label="应急演练记录" name="name7">
          <query-table
          :columnsFormatData="columnsFormatRecord"
          askData="emergencyRecordManage"
          :refreshData="update_count"
          main_width="1260px"
        ></query-table>
        </TabPane>
    </Tabs>
  </div>
</template>
<script>
import queryTable from "@/components/Common/QueryTable.vue";
export default {
  name: "emergency",
  components: {
    queryTable,
  },
  data() {
    return {
      value1: "",
      imgUrl: process.env.BASE_URL + "img/emergency.jpg",
      update_count: 0,
      description:{
        a:"<p>公司应急点按照“应急基地、应急值守点、车站”三级设置。</p><p>（一）应急基地</p><p>1.车辆段、停车场均设置为应急基地。</p><p>2.根据线网运营实际，分别选择洪柳车辆段、文家车辆段、中环停车场、红星路停车场、北郊车辆段、大丰停车场、板桥车辆段建设为线网应急基地；其他应急基地作为单线路应急基地。</p><p>3.公司可根据线路增加及线网运营应急需求变化，调整线网应急基地设置位置和数量。</p><p>（二）应急值守点</p><p>公司正线应急值守点分为区域应急值守点和专业应急值守点。各应急值守点的处置能力应能覆盖整个线网，原则上须满足“早晚客流高峰时段15分钟响应到位、其他运营时段20分钟响应到位”要求。</p><p>1.区域应急值守点。以确保突发事件及设备故障处置“快速响应、有效控制”为目的，结合线网运营应急响应实际需求，在各应急区域选择合适站点设置区域应急值守点。根据新增线路及应急处置需求变化，公司可对区域应急值守点数量、设置站点位置及人员配置标准等进行调整。区域应急值守点台账见附件1。</p><p>2.专业应急值守点（1）下属单位根据应急工作需求，结合生产工作及线网运营、跨线支援、资源共享等因素，于运营正线、OCC、供变电主所等设置专业应急值守点，作为区域应急值守点值守范围未覆盖区域的补充。（2）专业应急值守点结合正线驻站工班进行设置，原则上，正线驻站工班满足响应到位要求情况下，由正线驻站工班点承担专业应急值守点职责。（3）综合监控、通信、信号专业须于各OCC设置专业应急值守点，并满足“立即响应到位”要求。（4）信号、轨道专业须于折返站设置专业应急值守点，并满足“立即响应到位”要求。（5）接触网专业须于高架区段设置专业应急值守点，并配置电动车等路面交通工具，满足响应到位要求。</p>",
        b:'<p>（一）应急基地</p><p>线网应急基地，主要负责该区域（原则上为线网应急基地周边15公里半径范围内站点）内须调动大型专业设备的线网应急救援，其他应急基地主要负责单线路多专业联动处置的抢险救援。</p><p>（二）应急值守点 </p><p>1.区域应急值守点。负责运营期间值守范围（原则上为区域应急值守点周边5公里半径范围内站点）内车辆、接触网等常见设备故障及各类突发事件的快速响应和处置配合，确保故障和突发事件得到快速控制。</p><p>2.专业应急值守点。负责运营期间值守范围内本专业相关设备故障及突发事件的快速响应、故障确认、原因初步判断和前期处置。</p><p>（三）车站</p><p>负责属地管理范围内各类突发事件的初期控制，侧重于保障车站的正常运转。</p>',
        c:'<p>（一）应急基地</p><p>1.下属单位负责根据《运营公司应急物资及人员配置标准》（见附件6）配置应急抢险人员及各类应急救援物资。</p><p>2.针对线网应急基地，下属单位须在应急基地物资配置基础上增设排涝、吊装、破拆、接触网断线抢险设备、车辆起复等大型救援设备。</p><p>3.下属单位可根据应急处置需求增加应急抢险人员，以及应急物资种类、数量配置。</p><p>（二）应急值守点</p><p>1.区域应急值守点</p><p>（1）下属单位根据《运营公司应急物资及人员配置标准》（见附件6），并结合突发事件及设备故障响应和处置需求，负责所辖专业值守人员，以及常用、适用小型应急物资的配置。</p><p>（2）区域应急值守点配置值守人员须熟悉相关应急预案和执行流程，具备车辆、供电、接触网等设备常见故障处置经验和技能，能胜任区域应急值守工作。</p><p>（3）下属单位可根据应急处置需求增加应急值守人员，以及应急物资种类、数量配置。</p><p>2.专业应急值守点</p><p>（1）由下属单位结合生产及应急工作实际，制定专业应急值守点人员及物资配置标准，配置专业值守人员及适用应急物资。</p><p>（2）专业应急值守点配置值守人员须熟悉本专业现场处置方案，具备本专业设备常见故障处置经验和技能，持有相关专业上岗证书，能胜任专业应急值守工作。</p><p>（三）车站</p><p>1.下属单位负责根据《运营公司应急物资及人员配置标准》（见附件6），并结合车站生产、应急需求，配置应急处置人员及适用应急物资。</p><p>2.下属单位可根据应急处置需求增加应急处置人员，以及应急物资种类、数量配置。</p>',
        d:'<p>（一）应急基地</p><p>以“谁配置、谁管理”为原则，由下属单位负责应急基地所辖专业抢险人员及应急物资管理工作。下属单位须严格执行公司人员、物资管理相关规定，做好应急人员、物资日常管理工作，确保应急物资状态可用、账物相符（成都地铁线网资产管理及运营生产管理系统，下称“生产管理系统”），确保应急人员满足快速响应及处置需求。</p><p> （二）应急值守点</p><p> 1.区域应急值守点</p><p> （1）由属地管理单位承担所辖站点区域应急值守点的建设及归口管理工作，配置日常运转所需办公物资，并负责在生产管理系统中及时更新区域应急值守点台账。</p><p> （2）值守期间，值守人员需服从属地单位管理。值守人员所属单位需做好人员培训、考评等日常管理等工作。</p><p> （3）以“谁配置、谁管理”为原则，分公司负责做好应急物资申购配置、检修、报废、增配等管理工作。分公司须严格执行公司物资管理相关规定，特别是做好应急物资日常管理工作，确保应急物资状态可用、账物相符（生产管理系统）。</p><p> （4）分公司须细化制定区域应急值守点人员、物资内部管理具体办法。</p><p> 2.专业应急值守点</p><p> （1）以“谁设置、谁管理”为原则，由各分公司承担专业应急值守点建设及归口管理工作。另外，分公司须结合运营线路增加及应急工作需求变化，及时优化调整专业应急值守点，并在生产管理系统中及时更新专业应急值守点台账。</p><p> （2）分公司负责做好值守人员日常管理及应急能力提升培训，做好专业应急值守点应急物资维保、申购、送检、送修及报废等管理工作，确保应急物资状态可用、账物相符（生产管理系统）。</p><p> （3）分公司须细化制定专业应急值守点人员、物资内部管理具体办法。</p><p>（三）车站</p><p>1.运营分公司负责车站应急能力建设及归口管理工作，做好车站人员日常管理及应急能力提升培训，做好车站应急物资维保、申购、送检、送修及报废等管理工作，确保车站应急物资状态可用、账物相符（生产管理系统）。</p><p>2.运营分公司须细化制定车站人员、物资内部管理具体办法。</p>',
        e:'<p>（一）应急基地</p><p>1.运营分公司须根据各应急基地实际情况编制一场（段）一预案，详细收集应急基地周边医院、消防队、疏散场所、公交线路，以及所属街道办、派出所等应急信息，组织与周边应急处置相关单位建立应急联动及协作机制，细化应急值班与响应要求。</p><p>2.应急基地配置应急抢险人员按专业设置24小时值班电话，应急抢险人员接报应急响应要求后须在5分钟内完成集结并携带应急物资出动，原则上应满足“救援人员30分钟响应到位”要求。</p><p>3.在确保安全情况下，应急抢险人员须利用各类交通工具快速赶赴现场，积极、主动、科学开展现场处置。</p><p>4.应急基地配置的应急抢险人员、应急物资须严格服从线网指挥中心统一调配、安排、指挥。</p><p>（二）应急值守点</p><p>1.值守要求</p><p>（1）按时到岗和离岗，每日到岗后和离岗前须报本专业生产调度。</p><p>（2）值守期间，须身着干净、整洁维保服，随身携带配置有应急、行车、维修等通话组的800M手持台并确保其处于可用状态。接到应急响应信息后，按要求将800M手持台切换至指定频道。</p><p>（3）值守期间，严禁擅离值守范围，因特殊原因临时离开值守范围或800M手持台无法接收信号时，须向分公司专业生产调度报备（区域应急值守点还需同时向OCC调度报备）。</p><p>（4）值守期间，规范填写值班交接记录本，详细记录值守范围内设备故障及突发事件应急处置情况。</p><p>（5）严禁擅自使用应急物资、设备，严禁擅自开展与故障处置和应急处置无关作业，严禁存放与应急值守工作无关的物品，定期对应急物资、设备进行检查，确保状态、数量、存放符合要求。</p><p>（6）严禁将无关人员带入值守点逗留，严禁擅自接受外部人员采访。</p><p>（7）服从属地管理单位管理，按要求参与相关培训、演练、训练及联勤会议等。</p><p>2.响应要求</p><p>（1）运营线路发生设备故障、突发事件情况下，OCC调度或分公司生产调度可通过800M手持台、电话等方式通知值守人员响应。其中，OCC调度具有值守人员最高调度指挥权，值守人员对OCC调度命令严格执行。</p><p>（2）值守人员接报响应信息后，1分钟内携带800M、应急物资及工器具响应出动，根据调度要求将800M手持台切换至指定通话组，优先选用电客车，视情况选用电动车等其他交通工具，快速赶赴现场。</p><p>（3）值守人员将响应出动及到位信息及时通过公司企业微信、800M手持台及电话等方式告知各调度，并做好处置过程中的信息报送等工作。</p><p>（4）值守人员赶赴现场后，立即对突发事件或设备故障原因进行初步判断，确保安全情况下，按照“先通后复”原则开展处置工作。</p><p>（5）应急响应期间，各值守点间做好人员、技术、物资等协作支援，确保响应快速、处置高效。</p><p>（三）车站</p><p>1.运营分公司须根据各站实际情况编制一站一预案，详细收集车站周边医院、消防队、疏散场所、公交线路，以及所属街道办、派出所等应急信息，组织车站与周边接口单位、驻站公安等建立应急联动及协作机制，细化应急值班与响应要求。</p><p>2.车站配置人员实行24小时值班制度，并设置24小时值班电话，车站人员接报应急响应要求后，须立即响应到位。</p><p>3.车站配置应急人员、物资须严格服从线网指挥中心统一调配、安排、指挥。</p>',
        f:'<p>非运营期间，运营线路各场段、车站、供变电主所等站点的设备故障和突发事件应急保障工作由各分公司按照“全覆盖、快速响应、有效处置”原则，结合夜间生产工作实际，自行布设应急抢险人员，确保接报应急响应通知后，应急抢险人员能在5分钟内响应出动。</p>'
      },
      // data: [
      //   {
      //     title: "公安驻地",
      //     description:
      //       "虹桥火车站2|北翟路基地|中山公园2|人民广场1|上海马戏城1|新村路7|肇嘉浜路7|上海体育馆1|上海南站1|锦江乐园1|莲花路1|外环路1|西藏南路4|陆家浜路8|小南门9|东宝兴路3|民生路6|龙阳路2|延吉中路8",
      //     avatar: process.env.BASE_URL + "img/emergency/a1.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/1.jpg",
      //   },
      //   {
      //     title: "OCC",
      //     description:
      //       "紫藤路|颛桥|漕河泾开发区|隆德路|新闸路|新村路|西藏北路|东宝兴路|民生路",
      //     avatar: process.env.BASE_URL + "img/emergency/a2.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/2.jpg",
      //     remark: "",
      //   },
      //   {
      //     title: "专职消防队",
      //     description: "九亭基地|赛车场基地|江杨北路基地|龙阳路2",
      //     avatar: process.env.BASE_URL + "img/emergency/a3.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/3.jpg",
      //   },
      //   {
      //     title: "COCC",
      //     description: "汉中路",
      //     avatar: process.env.BASE_URL + "img/emergency/a4.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/4.jpg",
      //     remark: "",
      //   },
      //   {
      //     title: "CCR",
      //     description: "龙阳路",
      //     avatar: process.env.BASE_URL + "img/emergency/a5.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/5.jpg",
      //     remark: "",
      //   },
      //   {
      //     title: "折返停车线",
      //     description:
      //       "富锦路1|通河新村1|上海火车站1|人民广场1|徐家汇1|上海南站1|莘庄1|徐泾东2|虹桥火车站2|淞虹路2|威宁路2|中山公园2|南京西路2|上海科技馆2|龙阳路2|广兰路2|创新中路2|远东大道2|海天三路2|浦东国际机场2|江杨北路3|长江南路3|宜山路3|临平路4|蓝村路4|大木桥路4|闵行开发区5|港城路6|巨峰路6|民生路6|上海儿童医学中心6|高青路6|东方体育中心6|美兰湖7|祁华路7|上大路7|昌平路7|龙华中路7|耀华路7|杨高南路7|花木路7|沈杜公路8|曲阳路8|延吉中路8|市光路8|松江南站9|松江大学城9|佘山9|九亭9|中春路9|桂林路9|徐家汇9|马当路9|杨高中路9|航中路10|龙柏新村10|龙溪路10|宋园路10|新天地10|四川北路10|江湾体育场10|新江湾城10|嘉定北11|马路11|南翔11|真如11|云锦路11|三林11|浦三路11|罗山路11|迪士尼11|安亭11|花桥11|七莘路12|虹梅路12|国际客运中心12|隆昌路12|金海路12|金运路13|金沙江西路13|丰庄13|大渡河路13|世博大道13|滴水湖16|临港大道16|书院16|惠南东16|野生动物园16|航头东16",
      //     avatar: process.env.BASE_URL + "img/emergency/a6.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/6.jpg",
      //   },
      //   {
      //     title: "基地",
      //     description:
      //       "城北基地|赛车场基地|北翟路基地|陈太路基地|富锦路基地|江杨北路基地|殷行路基地|港城基地|金桥路基地|九亭基地|蒲汇塘路基地|梅陇基地|石龙路基地|中春基地|剑川路基地|浦江镇基地|三林基地|川杨河基地|龙阳路基地|治北基地|川沙基地|磁浮基地|吴中路基地",
      //     avatar: process.env.BASE_URL + "img/emergency/a7.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/7.jpg",
      //   },
      //   {
      //     title: "主变电站",
      //     description:
      //       "剑川路5|银都路5|莘庄1|上海体育馆1|陕西南路1|静安寺2|虹桥路3|宜山路3|隆德路11|曹杨路3|上海马戏城1|人民广场1|大木桥路4|长清路7|耀华路7|江月路8|长江南路3|东宝兴路3|海伦路4|临港大道16|惠南16|罗山路11|世纪公园2|杨高中路8|巨峰路6|江浦路8|川沙2|磁浮基地|浦东国际机场2|佘山9|宋园路10|北新泾2",
      //     avatar: process.env.BASE_URL + "img/emergency/a8.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/8.jpg",
      //   },
      //   {
      //     title: "防淹门",
      //     description:
      //       "金沙江西路13|丰庄13|中山公园2|隆德路11|曹杨路3|长寿路|汉中路1|江宁路|自然博物馆13|南京西路2|大木桥路4|世博会博物馆13|龙华中路7|后滩7|西藏南路4|中华艺术宫8|小南门9|商城路9|隆昌路12|复兴岛12|东陆路12|爱国路12|龙耀路11",
      //     avatar: process.env.BASE_URL + "img/emergency/a9.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/9.jpg",
      //   },
      //   {
      //     title: "风井",
      //     description:
      //       "上海赛车场11|金沙江西路13|丰庄13|淞虹路2|北新泾2|北翟路基地|交通大学10|星中路9|桂林路9|九亭基地|芦恒路8|凌兆新村8|东方体育中心6|后滩7|华夏西路6|三林11|西藏南路4|南浦大桥4|商城路9|川杨河基地|新场16|野生动物园16|惠南16|惠南东16|书院16|临港大道16|民生路6|北洋泾路6|德平路6|云山路6|金桥路6|博兴路6|金海路12",
      //     avatar: process.env.BASE_URL + "img/emergency/a10.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/10.jpg",
      //   },
      //   {
      //     title: "抢修点",
      //     description:
      //       "城北基地|赛车场基地|北翟路基地|陈太路基地|江杨北路基地|港城基地|金桥路基地|九亭基地|梅陇基地|中春基地|剑川路基地|浦江镇基地|三林基地|川杨河基地|龙阳路基地|治北基地|川沙基地|西藏中路|新闸路|北洋泾路6",
      //     avatar: process.env.BASE_URL + "img/emergency/a11.jpg",
      //     content: "",
      //     img: process.env.BASE_URL + "img/emergency/11.jpg",
      //   },
      //   {
      //     title: "抢修队",
      //     description:
      //       "九亭基地（b）|梅陇基地（a、c、d、e）|金桥路基地（c）|龙阳路基地（c）|治北基地（c）",
      //     avatar: process.env.BASE_URL + "img/emergency/a12.jpg",
      //     content:
      //       "其中：a、车辆起覆抢修队 b、通号道岔抢修队 c、供电触网抢修队 d、工务轨道抢修队 e、防台防汛抢修队；",
      //     img: process.env.BASE_URL + "img/emergency/12.jpg",
      //   },
      // ],
      columnsFormatData: [
        {
          title: "负责公司",
          key: "company",
          align: "center",
          width: 130,
        },
        // {
        //   title: "线路",
        //   key: "line_name",
        //   align: "center",
        //   width: 100,
        // },
        {
          title: "专业",
          key: "major",
          align: "center",
          width: 150,
        },
        {
          title: "值守点",
          key: "name",
          tooltip: "true",
          align: "center",
        },
        {
          title: "位置",
          key: "position",
          tooltip: "true",
          align: "center",
          width: 180,
        },
        {
          title: "覆盖范围",
          key: "res_area",
          tooltip: "true",
          align: "center",
          width: 180,
        },
        {
          title: "值班电话",
          key: "telephone",
          tooltip: "true",
          width: 110,
          align: "center",
        },
      ],
      columnsFormatGoods: [
        {
          title: "所属公司",
          key: "company",
          align: "center",
          width: 130,
        },
        {
          title: "线路名称",
          key: "line_name",
          align: "center",
          width: 100,
        },
        {
          title: "救援器材名称",
          key: "name",
          align: "center",
 
        },
        // {
        //   title: "规格型号",
        //   key: "model",
        //   tooltip: "true",
        //   align: "center",
        // },
        // {
        //   title: "用途",
        //   key: "gusage",
        //   tooltip: "true",
        //   align: "center",
        //   width: 120,
        // },
        {
          title: "数量",
          key: "amount",
          tooltip: "true",
          align: "center",
          width: 70,
        },
        {
          title: "单位",
          key: "unit",
          tooltip: "true",
          align: "center",
          width: 70,
        },
        {
          title: "储备地点",
          key: "position",
          tooltip: "true",
          align: "center",
          width: 100,
        },
        {
          title: "有效期",
          key: "valid_date",
          tooltip: "true",
          align: "center",
          width: 90,
        },
        {
          title: "检测维保日期",
          key: "repair_date",
          tooltip: "true",
          align: "center",
          width: 110,
        },
        // {
        //   title: "责任部门",
        //   key: "res_department",
        //   align: "center",
        //   width: 100,
        // },
        // {
        //   title: "责任人及电话",
        //   key: "res_person",
        //   tooltip: "true",
        //   align: "center",
        //   width: 120,
        // },
      ],
      columnsFormatArea: [
        {
          title: "负责公司",
          key: "company",
          align: "center",
          width: 130,
        },
        // {
        //   title: "线路",
        //   key: "line_name",
        //   align: "center",
        //   width: 100,
        // },
        {
          title: "专业",
          key: "major",
          align: "center",
          width: 150,
        },
        {
          title: "名称",
          key: "name",
          tooltip: "true",
          align: "center",
        },
        {
          title: "位置",
          key: "position",
          tooltip: "true",
          align: "center",
          width: 180,
        },
        {
          title: "覆盖范围",
          key: "res_area",
          tooltip: "true",
          align: "center",
          width: 180,
        },
        {
          title: "值班电话",
          key: "telephone",
          tooltip: "true",
          width: 110,
          align: "center",
        },
      ],
      columnsFormatScheme: [
        {
          title: "预案名称",
          key: "name",
          align: "center",
        },
        {
          title: "版次",
          key: "edition",
          align: "center",
          width: 150,
        },
        {
          title: "发布日期",
          key: "pubdate",
          tooltip: "true",
          align: "center",
        },
        {
          title: "执行日期",
          key: "exedate",
          tooltip: "true",
          align: "center",
          width: 180,
        },
        {
          title: "详情",
          key: "des",
          align: "center",
          width: 130,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: {},
                  on: {
                    click: () => {
                      this.linkTo(params.row.file_url);
                    }
                  }
                },
                "查看"
              )
            ]);
          }
        }
      ],
      columnsFormatPlan: [
        {
          title: "计划演练日期",
          key: "op_date",
          align: "center",
          width: 110,
        },
        {
          title: "演练科目",
          key: "name",
          tooltip: "true",
          align: "center",
        },
        {
          title: "演练类别",
          key: "catagory",
          tooltip: "true",
          align: "center",
          width: 100,
        },
        {
          title: "演练方式",
          key: "op_way",
          tooltip: "true",
          align: "center",
          width: 100,
        },
        {
          title: "演练级别",
          key: "glevel",
          tooltip: "true",
          align: "center",
          width: 100,
        },
        {
          title: "位置",
          key: "position",
          tooltip: "true",
          align: "center",
          width: 180,
        },
        {
          title: "组织单位",
          key: "leader_com",
          tooltip: "true",
          align: "center",
          width: 110,
        },
        {
          title: "配合单位",
          key: "other_com",
          tooltip: "true",
          align: "center",
          width: 180,
        },
      ],
       columnsFormatRecord: [
        {
          title: "演练日期",
          key: "op_date",
          align: "center",
          width: 110,
        },
        {
          title: "演练科目",
          key: "name",
          tooltip: "true",
          align: "center",
        },
        {
          title: "涉及预案",
          key: "scheme",
          tooltip: "true",
          align: "center",
        },
        {
          title: "演练方式",
          key: "op_way",
          tooltip: "true",
          align: "center",
          width: 100,
        },
        {
          title: "演练级别",
          key: "glevel",
          tooltip: "true",
          align: "center",
          width: 100,
        },
        {
          title: "位置",
          key: "position",
          tooltip: "true",
          align: "center",
          width: 180,
        },
        {
          title: "组织单位",
          key: "leader_com",
          tooltip: "true",
          align: "center",
          width: 100,
        },
        {
          title: "配合单位",
          key: "other_com",
          tooltip: "true",
          align: "center",
          width: 180,
        },
        {
          title: "计划状态",
          key: "if_plan",
          tooltip: "true",
          align: "center",
          width: 100,
        },
        {
          title: "双盲状态",
          key: "if_blind",
          tooltip: "true",
          align: "center",
          width: 100,
        },
      ],
    };
  },
  methods: {
    linkTo(value) {
      window.open(value, "_blank");
    },
  },
};
</script>
<style scoped>
.outer-wrapper {
  width: 100%;
  margin: 0 auto;
  font-size: 14px;
}
.top-content {
  display: flex;
}

.top-content img {
  width: 40%;
  border: 1px solid #333;
}
.left-content {
  width: 60%;
  padding: 30px 50px 30px 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

td,
th {
  height: 28px;
  border: 1px solid #666;
  text-align: center;
  padding: 0 10px;
}

.des-main {
  font-size: 18px;
  margin-top: 20px;
}

.des-title {
  font-size: 22px;
  font-weight: 500;
  text-indent: 0px;
  border-bottom: 1px solid rgb(44, 14, 14);
}

.content-i {
  text-indent: 36px;
  font-size: 18px;
  line-height: 36px;
  padding: 10px 20px;
}
</style>